import React from 'react';

const Head = () => {
    return (
        <div className="live-footer-wrap">
            <div className="live-footer">
                <div>
                    <div className="mb-tf">Công Ty TNHH MTV ĐẠI LÝ XỔ SỐ MINH NGỌC Minh Ngoc Lottery Agent Company Limited</div>
                    <div>MST: 0314553284 - Tel:  +8428 6266 2222 - 0973777779 119 Ngo Tat To Street, 22 Ward, Binh Thanh Dist, HCM City, Vietnam.</div>
                </div>
            </div>
            <div className="sub-live-footer"/>
        </div>
    );
};

export default Head;